import apiService from '@/services/apiService';

const actions = {
  getUniversalVouchersWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/universals/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`promo/voucher/universal/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/universals', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher/universal/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`promo/voucher/universals/${payload.app_name}/${payload.voucher_id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  getCampaignWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/campaigns/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getNonUniversalVouchers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universal/find-all', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  reserveNonUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universals/reserve', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;